import React, { Component } from 'react';

import { Row, Col } from 'antd';
import { ReactComponent as IconChevronLeft } from '../Sprites/icon-chevron-left.svg';
import { ReactComponent as IconChevronRight } from '../Sprites/icon-chevron-right.svg';

const getBreadcrumbText = (position, text) => (position === 0 ? 'Home' : text);

const BreadcrumbItem = ({ item, position, size }) => (
  <li
    className="page-breadcrumb__item"
    itemProp="itemListElement"
    itemScope
    itemType="http://schema.org/ListItem"
  >
    {size === 1 ? <BreadcrumbSeparatorLeft /> : <BreadcrumbSeparator />}
    <BreadcrumbLink item={item} position={position} size={size} />
    <meta itemProp="position" content={position + 1} />
  </li>
);

const BreadcrumbLink = ({ item, position, size }) => {
  const opts = {};
  if (size === position + 1) {
    opts['aria-current'] = 'page';
  }
  const url =
    item.asset_url.indexOf('/http-404') !== -1
      ? item.asset_url.slice(0, item.asset_url.indexOf('/http-404'))
      : item.asset_url;
  return (
    <a
      href={position === 0 ? '/' : url}
      itemProp="item"
      className="page-breadcrumb__link"
      {...opts}
    >
      {getBreadcrumbText(position, item.asset_name)}
    </a>
  );
};

const BreadcrumbSeparator = () => (
  <span className="page-breadcrumb__separator">
    <IconChevronRight />
  </span>
);

const BreadcrumbSeparatorLeft = () => (
  <span className="page-breadcrumb__separator">
    <IconChevronLeft />
  </span>
);

const BreadcrumbsList = ({ lineage, appearance }) => {
  const displayBreadcrumbItem = lineage.map((item, key) => (
    <BreadcrumbItem
      item={item}
      key={`breadcrumbitem-${key}`}
      appearance={appearance}
      position={key}
      size={lineage.length}
    />
  ));
  return (
    <ol
      itemScope
      itemType="http://schema.org/BreadcrumbList"
      className="page-breadcrumb__list"
    >
      {displayBreadcrumbItem}
    </ol>
  );
};
class Breadcrumbs extends Component {
  render() {
    const { lineage, appearance } = this.props;
    const pageLevel = lineage.length;
    const parentUrl = lineage[lineage.length - 2].asset_url;
    const parentName = lineage[lineage.length - 2].asset_name;
    return (
      <Row className="fixed page-breadcrumb">
        <Col xs={{ span: 0 }} lg={{ span: 24 }}>
          <nav aria-label="Breadcrumbs" className="page-breadcrumb__desktop">
            <BreadcrumbsList lineage={lineage} appearance={appearance} />
          </nav>
        </Col>
        <Col xs={{ span: 22, offset: 1 }} lg={{ span: 0 }}>
          <nav aria-label="Breadcrumbs" className="page-breadcrumb__mobile">
            <ol
              itemScope
              itemType="http://schema.org/BreadcrumbList"
              className="page-breadcrumb__list"
            >
              <li className="page-breadcrumb__item">
                <BreadcrumbSeparatorLeft />
                <a className="page-breadcrumb__link" href={parentUrl}>
                  {pageLevel === 2 ? `Home` : parentName}
                </a>
                <meta itemProp="position" content="1" />
              </li>
            </ol>
          </nav>
        </Col>
      </Row>
    );
  }
}

export default Breadcrumbs;
